export default {
  add: {
    position: 'absolute',
    top: 15,
    left: 0,
    zIndex: 1,
  },
  noDataRow: {
    textAlign: 'center',
  },
  noDataText: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
    fontStyle:'italic',
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  business: {
    color: 'lightgrey',
  },
}


// WEBPACK FOOTER //
// ./src/components/Customers/CustomersGrid/styles.js